import * as React from 'react';

interface TooltipFieldProps {
  label: string;
  children?: React.ReactNode;
}

export const TooltipField: React.FC<TooltipFieldProps> = ({ label, children }) => {

  return children && <p>
    {label
      ? <><b>{label}:</b> {children}</>
      : <b>{children}</b>}
  </p>;
};
